module.exports = __webpack_public_path__ + "static/media/muller-light.fbb65c9c.otf";